import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { iif } from 'rxjs';
import { CommonServices } from 'src/app/Common/CommonServices';
import { PlatformChargesClient, PlatformChargesGetDTO, RoomOwnerPlatformCharge, User } from 'src/app/Services/WOWApi.Service';
import { CommonService } from 'src/app/Services/common.service';

@Component({
    selector: 'app-edit-platform-charge',
    templateUrl: './edit-platform-charge.component.html',
    styleUrls: ['./edit-platform-charge.component.css'],
    standalone: false
})
export class EditPlatformChargeComponent implements OnInit {
  percentage: number = 0;
  originalPercentage: number = 0;
  platformCharge: RoomOwnerPlatformCharge;
  userDetails: User;
  isAddPercentage = false;
  isSubmitting = false;
  constructor(
    @Inject(MAT_DIALOG_DATA) public platformDto: PlatformChargesGetDTO,
    private dialogRef: MatDialogRef<EditPlatformChargeComponent>,
    private platformChargesClient: PlatformChargesClient,
    private commonServices: CommonServices,
    private commonService: CommonService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.userDetails = JSON.parse(localStorage.getItem("UserInfo"));
    if (this.platformDto !== undefined && this.platformDto !== null) {
      this.isAddPercentage = (this.platformDto.platformCharge !== undefined && this.platformDto.platformCharge !== null) ? false : true;
      if (this.platformDto.platformCharge !== undefined && this.platformDto.platformCharge !== null) {
        this.platformCharge = this.platformDto.platformCharge;
      }
      if (this.platformCharge !== undefined && this.platformCharge.percentage !== null && this.platformCharge.percentage !== undefined) {
        this.percentage = this.platformCharge.percentage;
        this.originalPercentage = this.platformCharge.percentage;
      } else {
        this.platformCharge = new RoomOwnerPlatformCharge();
      }
    }
  }

  onCancel() {
    this.dialogRef.close();
  }

  onUpdatePlatformCharge() {
    this.isSubmitting = true;
    if (this.userDetails === null || this.userDetails === undefined) {
      this.commonServices.showMessage('error', 'User details not found', 5);
      localStorage.removeItem("UserInfo"); 
      this.commonService.setUserLoggedIn(false);
      this.router.navigateByUrl('/login');
      this.isSubmitting = false;
      return;
    }
    if (this.percentage > 99) {
      this.commonServices.showMessage('error', 'Platform charge can not be greater than 99%', 5);
      this.isSubmitting = false;
      return;
    }
    if (this.percentage < 0) {
      this.commonServices.showMessage('error', 'Platform charge can not be less than 0%', 5);
      this.isSubmitting = false;
      return;
    }
    if (this.percentage > 0) {
      this.platformCharge.percentage = this.percentage;
      this.platformCharge.webinarRoomOwnerId =  this.platformDto.user.id;
    }
    if (this.platformCharge === undefined) {
      this.platformCharge.platformChargesId = 0;
    }
    const addApi = this.platformChargesClient.addPlatformCharge( this.userDetails.id, this.platformCharge);
    const updateApi = this.platformChargesClient.updatePlatformCharge(this.userDetails.id, this.platformCharge);
    iif(() => this.isAddPercentage, addApi, updateApi).subscribe(res => {
      this.platformDto.platformCharge = this.platformCharge;
      this.isSubmitting = false;
      this.dialogRef.close({action: 'success', obj: this.platformDto});
    }, error => {
      this.commonServices.showMessage('error', error, 5);
      this.isSubmitting = false;
    })
  }


  onlyDecimalAllowed(event: KeyboardEvent) {
    const input = String.fromCharCode(event.charCode);
    const pattern = /^[0-9.]+$/;
    if (!pattern.test(input)) {
      event.preventDefault();
      this.commonServices.showMessage('error', 'Decimal only', 2);
    }
  }
}
